import React from 'react';

export default function SenderWrapper({text}) {
    const RenderHTML = props => (<span dangerouslySetInnerHTML={{__html: props.HTML}} className="cl-break-space"/>)

    return <RenderHTML HTML={text}/>
}


// WEBPACK FOOTER //
// ./src/components/Body/Sender/wrapper.js